let promoCodesByProductId = {
    VIP30: [
      7618485616795, 8969249685841, 7618478145691, 8858437091665, 7618484437147, 8930931212625, 7122525880475,
      9136737026385, 9135027487057, 7518777344155, 7611419951259, 8641877672273, 8641885143377, 8930927247697,
      8960265453905, 8930890482001, 9102053310801, 9102062387537, 9102003700049, 8926702567761, 8985420890449,
      8980276150609, 8926698963281, 8980261405009, 7534195966107, 8961559757137, 8961558577489, 8961518666065,
      9142797500753, 9142882140497, 9142836461905, 9142878667089, 8959816368465, 8959818793297, 8959820136785,
      8959819841873, 8732145385809, 8732146401617, 8732144042321, 8732144828753, 8731492090193, 8732164424017,
      8968972173649, 7493822382235, 7493743935643, 7493825888411, 8731492286801, 8996449026385, 9101913358673,
      8790257959249, 8790257566033, 8790259663185, 8790259859793, 8979891913041, 8979916128593, 8979905610065,
      8979901579601, 8979890700625, 8979889946961, 8996215816529, 8617624076625, 8764589670737, 8764616802641,
      7617728708763, 7617729888411, 7367475593371, 7600843718811, 8764673196369, 8764666806609, 8764671885649,
      8996231119185, 9136777789777, 7377954144411, 8764656648529, 7600857841819, 8996455940433, 8617628827985,
      8617643245905, 8617637773649, 8996457480529, 8996457054545, 7600859250843, 8764664873297, 7600858366107,
      8764663234897, 9158895108433, 9158920044881, 9134986690897, 9134972731729, 7197985669275, 7197992124571,
      7537335468187, 7537337467035, 7282814582939,
    ],
    VIP40: [
      7611422998683, 8959822233937, 8930942091601, 8926670094673, 8980185710929, 8927724732753, 8364315607377,
      8927703695697, 9136743022929, 9136731193681, 8961552056657, 8757269791057, 8858424836433, 8969276784977,
      8969282126161, 8959838159185, 9012016382289, 8959850578257, 8927856787793, 8927874548049, 9101895991633,
      8959846646097, 8959847137617, 8927742296401, 8927863963985, 8927758221649, 7616678953115,
    ],
    VIP50: [
      8930930950481, 7616687440027, 8366923186513, 8732155773265, 8732154888529, 8961401258321, 8927888114001,
      8932385096017, 8770764046673, 8770749038929,
    ],
  };